export const ApiMethodConstants = {
  HealthCenters: 'healthcenters',
  Mshs: 'mshs',
  Hccn: 'hccn',
  Opo: 'opo',
  RyanWhite: 'ryanwhite'
};
